import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { build, pool } from '../../../../../common/classes/request-builder';
import { ReactiveFormChangedField, ReactiveFormValue } from '../../../../../common/components/reactive-form-builder/interfaces/reactive-form-change.interface';
import { BaseForm } from '../../../../base-form';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ControlSanitarioModel } from '../../../../../models/tareas/control-sanitario.model';
import { ControlSanitarioFormDefinition } from './form-control/form-definition';
import { environment } from '../../../../../../environments/environment';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';

@Component({
    selector: 'app-control-sanitario-form',
    standalone: false,
    templateUrl: './control-sanitario-form.component.html',
    styleUrls: ['./control-sanitario-form.component.scss']
})
export class ControlSanitarioFormComponent extends BaseForm<ControlSanitarioModel> implements OnInit {
    public form!: ControlSanitarioFormDefinition;
    public formReady = false;
    public loadingData = true;
    public getRequest = this.tareasApi.controlSanitario.GET;
    public readonly serverUrl = environment.serverUrl;

    constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public tareasApi: TareasApiService,
        public fincasApi: FincasApiService,
        public override router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            tareasApi.controlSanitario.PUT,
            tareasApi.controlSanitario.POST,
            'control-sanitario',
            'Actualizar Control Sanitario',
            'Realizar Control Sanitario',
            'Duplicar Control Sanitario'
        );
    }

    public ngOnInit(): void {
        this.softInit(this.getType());
        void this.setupForm();
    }

    public formChanges(
        formModel: ReactiveFormValue<ControlSanitarioModel>,
        lastChangedFieldName: ReactiveFormChangedField<ControlSanitarioModel>,
    ): void {
        this.form.model = {
            ...this.form.model,
            ...formModel,
        };

        if (String(lastChangedFieldName) === 'id_finca') {
            this.dropdownLoadTrigger.next();
        }
    }

    private async setupForm(): Promise<void> {
        this.model = this.getModel() as ControlSanitarioModel;
        this.form = new ControlSanitarioFormDefinition(this.getType(), this.model);

        await this.initFormData();

        this.formReady = true;
    }

    private async initFormData(): Promise<boolean> {
        this.loadingData = true;
        this.dropdownsFinalized = false;

        return pool([
            build(this.fincasApi.fincasGET, this.form.fincas, 'nombre', true),
        ], () => this.dropdownLoadTrigger.next())
            .then(() => {
                this.applyCreationDefaults();
                this.loadingData = false;
                this.dropdownsFinalized = true;
                this.dropdownLoadTrigger.next();

                return true;
            })
            .catch((error: unknown) => {
                this.loadingData = false;
                this.dropdownsFinalized = true;
                this.dropdownLoadTrigger.next();
                console.error('Error loading control sanitario form data.', error);

                return true;
            });
    }

    private applyCreationDefaults(): void {
        if (this.getType() !== FormType.CREATION || this.form.model.id_finca || this.form.fincas.values.length !== 1) {
            return;
        }

        this.form.model.id_finca = this.form.fincas.values[0]?.value?.id ?? null;
    }

}
